<template>
    <div>
        <div class="col-12 mb-4 d-flex justify-content-between align-items-baseline">
            <h4 v-if="locationType === 'job'">Job locations</h4>
            <h4 v-if="locationType === 'company'">Address book</h4>
            <button @click="newLocation" :disabled="loading" class="btn btn-primary">
            New location
            </button>
        </div>
        <AppTable
            :columns="columns"
            ref="table"
            :rows="locations"
            :query="query"
            @on-row-click="viewLocation"
            :loading="loading"
            :total="total"
            @on-query-change="onQueryChange"
        />
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AppTable from '../form/AppTable';

export default {
  components: {
    AppTable,
  },
  computed: {
    ...mapGetters({
      locations: 'locations/locations',
    }),
    ...mapState({
      total: (state) => state.locations.totalLocations,
    }),
    query() {
      return this.$store.state.locations.query[this.locationType];
    },
    locationType() {
      return this.$route.params.locationType;
    },
    columns() {
      return [
        {
          label: 'Address',
          field: 'address',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Postal code',
          field: 'postal_code',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'City',
          field: 'city',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Country',
          field: 'country.name',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Region',
          field: 'region.name',
          filterOptions: {
            enabled: true,
          },
        },
      ];
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.getLocations();
  },
  watch: {
    '$route.params.locationType'() {
      this.$refs.table.reset();
      this.getLocations();
    },
  },
  methods: {
    newLocation() {
      this.$router.push({
        name: 'location',
        params: {
          locationType: this.locationType,
          locationId: 'new',
        },
      });
    },
    viewLocation(event) {
      this.$router.push({
        name: 'location',
        params: { locationId: event.row.id },
      });
      this.$store.commit('locations/locationId', event.row.id);
    },
    getLocations() {
      this.loading = true;
      this.$store.dispatch('locations/getLocations', this.locationType)
        .finally(() => {
          this.loading = false;
        });
    },
    onQueryChange(props) {
      this.$store.commit('locations/queryProps', {
        props,
        locationType: this.locationType,
      });
      this.getLocations();
    },
  },
};
</script>
